import { Injectable } from '@angular/core';

import { GaugeLabel, GaugeSegment } from '../../3rd-party/gauge';

@Injectable({
  providedIn: 'root'
})
export class PlanProgressService {
   prepareGaugeData(dataList) {
    let color;
    let tempDataObj;
    let tempObj;
    const gaugeArray = [];
    for (let i = 0; i < dataList.length; i++) {
      color = this.parseGaugeColor(dataList[i].name);
      tempDataObj = {
        bgRadius: 0,
        bgColor: '#fff',
        rounded: false,
        reverse: true,
        animationSecs: 1,
        height: '70px',
        width: '70px',
        labels: [
          new GaugeLabel({
            color: '#959595',
            text: dataList[i].value,
            x: 0,
            y: 12,
            fontSize: '2.3em',

          })
        ],
        segments: [
          new GaugeSegment({
            value: dataList[i].percentage * 100,
            color: color,
            borderWidth: 20,
            bgColor: '#eee',
            goal: 100
          })

        ]
      };
      tempObj = { data: tempDataObj, name: dataList[i].name };
      gaugeArray.push(tempObj);
    }
    return gaugeArray;

  }

  parseGaugeColor(val) {
    let color: string;

    if (val === 'Student Success' || val === 'Financial Aid') {
      color = '#eb5867';
    } else if (val === 'Majors and Careers' || val === 'Applying to Colleges') {
      color = '#f0d394';
    } else if (val === 'Choosing Colleges' || val === 'Testing') {
      color = '#8ee2c8';
    } else {
      color = '#7f97e9';
    }

    return color;
  }

}
